import * as React from "react";

import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { useAppDispatch } from "app.hook";
import {
  closeConfirmModal,
  showConfirmModal,
} from "states/global-value/global-value.slice";
import { ConfirmModel } from "states/global-value/global-value.models";
import { ShoppingCartItem } from "states/shopping-cart/shopping-cart.models";
import {
  calculateTotal,
  removeItemShoppingCart,
  updateQuantityItemShoppingCart,
} from "states/shopping-cart/shopping-cart.slice";
import { nanoid } from "@reduxjs/toolkit";
import { IconMinus, IconPlus, IconTrash } from "themes";
export interface IButtonModalViewCartProps {
  item: ShoppingCartItem;
  index: number;
}

export function ItemModalViewCart({ item, index }: IButtonModalViewCartProps) {
  const dispatch = useAppDispatch();
  const handleRemove = () => {
    dispatch(removeItemShoppingCart(index));
    dispatch(closeConfirmModal());
  };

  const handleUpdateQuantity = (quantity: number) => {
    dispatch(updateQuantityItemShoppingCart({ index, quantity }));
  };

  return (
    <>
      <tr>
        <td>
          <div className="img--container-center bg--primary">
            {item.image !== "" ? (
              <img
                className="w-full "
                src={redirectFileLocalUrl(item.image)}
                alt=""
              />
            ) : (
              <div className="avatar-thumb rounded-full  bg-white" />
            )}
          </div>
        </td>
        <td className="w-2/4 align-top">
          <div className="name text-md font-medium">{item?.name} | {formatMoney(item.price, 2, ".", ",", "$")}</div>
          <div className="modifiers">
            {item?.modifiers?.map((modi) => (
              <span key={nanoid()}>{modi.name} | {formatMoney(modi.price, 2, ".", ",", "$")}</span>
            ))}
          </div>
        </td>
        <td>
          <div className="quantity-container flex flex-row content-center items-center justify-between">
            <button
              onClick={() => {
                if (item.quantity === 1) {
                  return;
                }
                handleUpdateQuantity(item.quantity - 1);
              }}
              className="btn--default outline-none"
            >
              <IconMinus className="fill-img-white" width={20} />
            </button>
            <span>{item.quantity}</span>
            <button
              onClick={() => {
                handleUpdateQuantity(item.quantity + 1);
              }}
              className="btn--default outline-none"
            >
              <IconPlus className="fill-img-white" width={20} />
            </button>
          </div>
        </td>
        <td className="text-center">
          {formatMoney(calculateTotal(item), 2, ".", ",", "$")}
        </td>
        <td className="text-center">
          <button
            onClick={() => {
              dispatch(
                showConfirmModal({
                  title: "Warning",
                  message: "Are you sure, you want to delete this?",
                  onYes: () => {
                    handleRemove();
                  },
                } as ConfirmModel)
              );
            }}
            className="btn--default"
          >
            <IconTrash width={20} />
          </button>
        </td>
      </tr>
    </>
  );
}
